import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "backdrop", "panel"]

  declare readonly modalTarget: HTMLElement
  declare readonly backdropTarget: HTMLElement
  declare readonly panelTarget: HTMLElement

  connect() {
    // Ensure modal is hidden initially if not already
  }

  open(event?: Event) {
    if (event) event.preventDefault()

    // Show modal container
    this.modalTarget.classList.remove("hidden")

    // Trigger animations in next frame
    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.backdropTarget.classList.add("opacity-100")
      
      this.panelTarget.classList.remove("translate-y-full")
      this.panelTarget.classList.add("translate-y-0")
    })

    // Prevent scrolling on body
    document.body.classList.add("overflow-hidden")
  }

  close(event?: Event) {
    if (event) event.preventDefault()

    // Reverse animations
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")
    
    this.panelTarget.classList.remove("translate-y-0")
    this.panelTarget.classList.add("translate-y-full")

    // Wait for animation to finish before hiding
    setTimeout(() => {
      this.modalTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }, 500) // Matches duration-500
  }
}
